module.exports = __webpack_public_path__ + "img/dogecoin.d24631c5.png";